export default __webpack_public_path__ + "28732628223a4e66146851f1b30cb389.png";